import TenanciesBaseState from '../shared/TenanciesBaseState';
import TenantTenancyState from './TenantTenancyState';

class TenanciesState extends TenanciesBaseState {
  constructor(root) {
    super(root, {
      expression: () => this.root.publicAccount.data.tenantTenancyUids,
      ItemClass: TenantTenancyState,
    });
  }
}

TenanciesState.annotations = {
  ...TenanciesBaseState.annotations,
};

export default TenanciesState;
